import { render } from "./PutStorageDialog.vue?vue&type=template&id=3cb2d479&scoped=true"
import script from "./PutStorageDialog.vue?vue&type=script&lang=js"
export * from "./PutStorageDialog.vue?vue&type=script&lang=js"

import "./PutStorageDialog.vue?vue&type=style&index=0&id=3cb2d479&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb2d479"]])

export default __exports__